/**
 * @fileoverview Connect archive/source metadata to consistent labels, filters, and preview/download locations across document views. `archiveReviewUtils.js` owns underlying source/review conventions and `DocumentFileTypeIcon.js` owns format signifiers. These browser projections preserve source identity without becoming storage ownership or access grants.
 */

import { apiUrl } from './archiveReviewUtils';
import { documentFileType } from './DocumentFileTypeIcon';



export function documentRevisionId(document) {
  return document?.revision_id || document?.latest_revision_id || document?.file_manager?.latest_revision_id || '';
}



export function documentInternalUrl(document) {
  const documentId = document?.document_id || document?.id;
  if (!documentId) return '';
  const url = new URL(`/documents/${encodeURIComponent(documentId)}`, window.location.origin);
  const revisionId = documentRevisionId(document);
  if (revisionId) url.searchParams.set('version', revisionId);
  return url.toString();
}



export function documentDownloadSource(document) {
  const revisionId = documentRevisionId(document);
  if (revisionId) {
    return apiUrl(`/simul/archive/versions/${encodeURIComponent(revisionId)}/download`);
  }
  const documentId = document?.document_id || document?.id || '';
  if (documentId && document?.available_locally !== false) {
    return apiUrl(`/simul/archive/transfers/documents/${encodeURIComponent(documentId)}/original`);
  }
  return '';
}



export function documentPreviewSource(document, type = documentFileType(document)) {
  const revisionId = documentRevisionId(document);
  if (type === 'image' && document?.thumbnail_url) return apiUrl(document.thumbnail_url);
  if (!revisionId) return '';
  const encodedRevisionId = encodeURIComponent(revisionId);
  if (['image', 'audio', 'video'].includes(type)) {
    return apiUrl(`/simul/archive/versions/${encodedRevisionId}/download`);
  }
  if (String(document?.filename || '').toLowerCase().endsWith('.rtf')) {
    return apiUrl(`/simul/archive/versions/${encodedRevisionId}/preview-pdf`);
  }
  if (['archive', 'code', 'csv', 'file', 'text'].includes(type)) return '';
  return apiUrl(`/simul/archive/versions/${encodedRevisionId}/preview-pdf`);
}



export function documentFirstPagePreviewSource(document, type = documentFileType(document)) {
  if (['image', 'audio', 'video'].includes(type)) {
    return documentPreviewSource(document, type);
  }
  if (['archive', 'code', 'csv', 'text'].includes(type)) return '';
  const revisionId = documentRevisionId(document);
  if (!revisionId) return '';
  return apiUrl(`/simul/archive/versions/${encodeURIComponent(revisionId)}/preview-first-page`);
}
